import { render, staticRenderFns } from "./dc-sel-page.vue?vue&type=template&id=2ce93d52&scoped=true"
import script from "./dc-sel-page.vue?vue&type=script&lang=js"
export * from "./dc-sel-page.vue?vue&type=script&lang=js"
import style0 from "./dc-sel-page.vue?vue&type=style&index=0&id=2ce93d52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce93d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce93d52')) {
      api.createRecord('2ce93d52', component.options)
    } else {
      api.reload('2ce93d52', component.options)
    }
    module.hot.accept("./dc-sel-page.vue?vue&type=template&id=2ce93d52&scoped=true", function () {
      api.rerender('2ce93d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/dc-sel-page.vue"
export default component.exports